export default __webpack_public_path__ + "static/media/DIJKExp.0be9daff.md";